import React, { useContext, useEffect } from 'react';
import Footer from '../Footer/Footer';
import Navbar from '../Navbar/Navbar';
import Categories from './Categories';
import ScrollToTop from "react-scroll-to-top";
import categoriesData from '../../fakeData/categoriesData';
import { collectionContext } from '../../App';
const CategoryPage = () => {
    const { value5 } = useContext(collectionContext);

    const [, setPage] = value5;
    useEffect(() => {
        setPage(1);
        // eslint-disable-next-line
    }, [])
    return (
        <>
            <ScrollToTop smooth />
            <Navbar />
            <Categories title={'Categories'} categoriesData={categoriesData} />
            <Footer />
        </>
    );
};

export default CategoryPage;